export default __webpack_public_path__ + "static/media/draw-icon.1e33696f.svg";